import type { RootState } from '../../../store';

/**
 * Settlement 검색 관련 selectors (POST /settlement/m/sch)
 */
export const selectSettlementSearchStatus = (state: RootState) => state.settlement.searchStatus;
export const selectSettlementSearchError = (state: RootState) => state.settlement.searchError;
export const selectSettlementSearchResults = (state: RootState) => state.settlement.searchResults;
export const selectSettlementSearchMeta = (state: RootState) => state.settlement.searchMeta;

/**
 * 후원금 내역 합계 관련 selectors (POST /mgmtcommission/m/sum)
 */
export const selectCommissionSumStatus = (state: RootState) => state.settlement.commissionSumStatus;
export const selectCommissionSumError = (state: RootState) => state.settlement.commissionSumError;
export const selectCommissionSumResults = (state: RootState) => state.settlement.commissionSumResults;
export const selectCommissionSumMeta = (state: RootState) => state.settlement.commissionSumMeta;
export const selectCommissionSumExtra = (state: RootState) => state.settlement.commissionSumExtra;

/**
 * 후원금 내역 조회 관련 selectors (POST /mgmtcommission/m/sch)
 */
export const selectCommissionSearchStatus = (state: RootState) => state.settlement.commissionSearchStatus;
export const selectCommissionSearchError = (state: RootState) => state.settlement.commissionSearchError;
export const selectCommissionSearchResults = (state: RootState) => state.settlement.commissionSearchResults;
export const selectCommissionSearchMeta = (state: RootState) => state.settlement.commissionSearchMeta;

/** 후원자(거래) 조회 (POST /transactions/m/sch) */
export const selectTransactionSearchStatus = (state: RootState) => state.settlement.transactionSearchStatus;
export const selectTransactionSearchError = (state: RootState) => state.settlement.transactionSearchError;
export const selectTransactionSearchResults = (state: RootState) => state.settlement.transactionSearchResults;
export const selectTransactionSearchMeta = (state: RootState) => state.settlement.transactionSearchMeta;

